import { useQuery } from '@tanstack/react-query';
import { apiGet } from './client';

export interface RegisteredPermission {
  id: string;
  permission: string;
  service_id: string;
  description: string;
}

export function usePermissions() {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => apiGet<RegisteredPermission[]>('/api/permissions'),
    staleTime: 5 * 60_000, // 5 minutes — registry rarely changes
  });
}
